import { Component, Host, h, Element, Prop } from '@stencil/core';
import { Size } from '../aha-pill/types';

export interface AhaUserTag extends HTMLAhaUserTagElement {}

/**
 * A tag with an avatar image and name.
 */
@Component({
  tag: 'aha-user-tag',
  styleUrl: 'aha-user-tag.css',
  shadow: true,
})
export class AhaUserTag {
  @Element() host!: HTMLAhaUserTagElement;

  @Prop() avatarUrl?: string;

  @Prop() name?: string;

  @Prop() label?: string;

  @Prop() size?: Size = 'medium';

  render() {
    const avatarSize = this.size === 'small' ? 14 : 18;

    return (
      <Host>
        <aha-pill border-color="var(--theme-primary-border)" border-shape="round" size={this.size}>
          <div class="wrapper">
            <aha-avatar
              size={avatarSize}
              src={this.avatarUrl}
              name={this.name}
              label={this.label}
            />
            <span class="username">{this.name}</span>
          </div>
        </aha-pill>
      </Host>
    );
  }
}
